module.exports = __webpack_public_path__ + "static/media/salesforce-icon.019819f5.svg";